import { Injector } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SpinnerService } from '../../services/spinner.service';
import { ToasterService } from '../../services/toaster.service';
import { AuthService } from '../../services/auth.service';


export class BaseClass {
  public authService: AuthService;
  public route: ActivatedRoute;
  public formBuilder: FormBuilder;
  public spinnerService: SpinnerService;
  public router: Router;
  public toasterService: ToasterService;
  public translateService: TranslateService;

  constructor (injector: Injector) {
    this.route = injector.get(ActivatedRoute);
    this.authService = injector.get(AuthService);
    this.formBuilder = injector.get(FormBuilder);
    this.spinnerService = injector.get(SpinnerService);
    this.router = injector.get(Router);
    this.toasterService = injector.get(ToasterService);
    this.translateService = injector.get(TranslateService);
  }

  public scrollToDiv() : void {
    const element = document.getElementById('targetDiv');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth',
        block: 'start' });
    }
  }
}